<form class="m-h-12 m-v-8"
  [formGroup]="form">
  <h3>{{ 'sigt.integration.rechercheGdf.form.recherche.titreCritereRecherche' | translate }}</h3>

  <mat-form-field class="d-flex tour-interactif-step-3-step-0">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.avisPriseProssessionGdf.numero' | translate }}</mat-label>
    <input formControlName="numero"
      matInput
      class="form-control"
      maxlength="12">
      <mat-error *ngIf="form.controls.numero.errors?.required">
        {{messageApplication.obligatoireNumero}}
      </mat-error>
  </mat-form-field>

  <div class="boutons-en-grille">
    <button mat-raised-button type="button"
      class="clear-search-button tour-interactif-gdf-reinitialiser"
      (click)="initialiserChamps()">
      {{ 'sigt.global.boutons.reinitialiser' | translate }}
    </button>

    <button mat-raised-button
      class="search-button tour-interactif-gdf-rechercher"
      [disabled]="!form.valid"
      (click)="rechercher()"
      color="primary">
      {{ 'sigt.global.boutons.rechercher' | translate }}
    </button>
  </div>
</form>
